import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import SearchInput from './SearchInput';
import { Button } from '@mui/joy';

const Globe = 'assets/images/stash_globe.png'
const Logo = 'assets/images/fundi_tz_logo_high_res_1final 1.png'

const HeaderOne = () => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (

        <>
            <Box sx={{ width: '100%', backgroundColor: '#FFFFFF', height: '164px' }}>

                <Box sx={{ width: '1153px', margin: 'auto' }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ height: '100%', paddingTop: 3 }}>

                        <Box>
                            <img src={Logo} alt="Fundi Logo" style={{ width: '130px', height: '124px' }} />
                        </Box>
                        <Box>
                            <nav>
                                <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>




                                    <Box display="flex" alignItems="center" gap={3}>
                                        {!isLoggedIn ? (
                                            <>
                                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-around', alignItems: 'center' }}>


                                                    <Box sx={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <img src={Globe} alt="Globe" style={{ width: 18, height: 18 }} />
                                                            <Box sx={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: 600, color: '#666666' }}>En</Box>
                                                        </Box>
                                                        <Link to="/login" style={{ textDecoration: 'none' }}>
                                                            <Typography variant="body1" sx={{
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '16px',
                                                                fontWeight: 600,
                                                                color: '#666666',
                                                                textDecoration: 'none',

                                                            }}>Log In</Typography>

                                                        </Link>
                                                        <Link to="/signup">
                                                            <Button
                                                                sx={{
                                                                    width: '118px',
                                                                    height: '35px',
                                                                    borderRadius: '7px',
                                                                    backgroundColor: '#666666',
                                                                    color: '#fff',
                                                                    fontFamily: 'Montserrat',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    border: 'none',
                                                                    '&:hover': {
                                                                        backgroundColor: '#666666',
                                                                    },


                                                                }}
                                                            >
                                                                Sign Up
                                                            </Button>
                                                        </Link>

                                                    </Box>
                                                </Box>
                                            </>
                                        ) : (

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                              
                                                <Box sx={{ display: 'flex', gap: 3 }}>
                                                    <NavLink
                                                        to="/"
                                                        style={({ isActive }) => ({
                                                            color: isActive ? '#28A745' : '#666666',
                                                            textDecoration: 'none',
                                                            fontSize: 16,
                                                            fontWeight: 600,


                                                        })}
                                                    >
                                                        Home
                                                    </NavLink>
                                                    <NavLink
                                                        to="/job"
                                                        style={({ isActive }) => ({
                                                            color: isActive ? '#28A745' : '#666666',
                                                            textDecoration: 'none',
                                                            fontSize: 16,
                                                            fontWeight: 600,
                                                        })}
                                                    >
                                                        Jobs
                                                    </NavLink>

                                                    <NavLink
                                                        to="/notification"
                                                        style={({ isActive }) => ({
                                                            color: isActive ? '#28A745' : '#666666',
                                                            textDecoration: 'none',
                                                            fontSize: 16,
                                                            fontWeight: 600,
                                                        })}
                                                    >
                                                        Notification
                                                    </NavLink>
                                                </Box>

                                            
                                                <Button
                                                    component={NavLink}
                                                    to="/job-post"
                                                    sx={{
                                                        backgroundColor: '#28A745',
                                                        color: '#000',
                                                        fontSize: '16px',
                                                        fontFamily: 'Montserrat',
                                                        fontWeight: 600,
                                                        padding: '4px 20px',
                                                        borderRadius: '7px',
                                                        textDecoration: 'none',
                                                        '&:hover': {
                                                            backgroundColor: '#28A745',
                                                        },
                                                    }}
                                                >
                                                    Post a Job
                                                </Button>

                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <SearchInput />
                                                </Box>

                                              
                                                <Box sx={{ display: 'flex', gap: 3 }}>
                                                    <Box>
                                                        <img width="21px" height="23px" src="assets/images/icons/Vector.png" alt="" />
                                                    </Box>
                                                    <Box>
                                                        <img width="20px" height="17px" src="assets/images/icons/Vector2.png" alt="" />
                                                    </Box>
                                                    <Box>
                                                        <img width="41px" height="41px" src="assets/images/icons/Group.png" alt="" />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </nav>
                        </Box>
                    </Box>
                </Box>
            </Box>

        </>
    );
};

export default HeaderOne;
